import { DEMO_DATASET_ID, DEMO_RESULTS_READY_KEY, DEMO_SUBID } from './constants.js'
import { loadDemoFixture } from './fixture.js'

export function demoResultsReady() {
  return sessionStorage.getItem(DEMO_RESULTS_READY_KEY) === '1'
}

export function clearDemoResults() {
  sessionStorage.removeItem('processingResults')
  sessionStorage.removeItem(DEMO_RESULTS_READY_KEY)
}

export function markDemoResultsReady() {
  sessionStorage.setItem(DEMO_RESULTS_READY_KEY, '1')
}

export async function buildDemoConfiguredData() {
  const fixture = await loadDemoFixture()
  const rows = Array.isArray(fixture.processed_dataset) ? fixture.processed_dataset : []
  const preview = rows.slice(0, 50)
  const summary = fixture.processing_summary || {}
  return {
    subid: DEMO_SUBID,
    dataset_id: DEMO_DATASET_ID,
    dataset_identifier: DEMO_DATASET_ID,
    session_id: fixture.session_id,
    filename: fixture.filename || 'demo_data.csv',
    data_timezone: fixture.data_timezone || 'US/Central',
    finalSamplingRate: summary.sampling_rate || 1,
    initialSamplingRate: summary.sampling_rate || 1,
    configuredRows: summary.configured_rows || rows.length,
    dayCount: Array.isArray(fixture.day_level_data) ? fixture.day_level_data.length : 0,
    headers: preview[0] ? Object.keys(preview[0]) : [],
    data: preview,
    data_stored_in_s3: false
  }
}

export async function buildDemoProcessingResults() {
  const fixture = await loadDemoFixture()
  const rows = Array.isArray(fixture.processed_dataset) ? fixture.processed_dataset : []
  return {
    success: true,
    session_id: fixture.session_id,
    subid: fixture.subid || DEMO_SUBID,
    dataset_identifier: fixture.dataset_identifier || DEMO_DATASET_ID,
    filename: fixture.filename,
    data_timezone: fixture.data_timezone,
    curve_features: fixture.curve_features || [],
    day_level_data: fixture.day_level_data || [],
    processing_summary: fixture.processing_summary || {},
    column_metadata: fixture.column_metadata || {},
    flag_selections: fixture.flag_selections || {},
    drinking_day_score_meta: fixture.drinking_day_score_meta || {},
    data_metadata: {
      total_rows: rows.length,
      start_time: rows[0]?.datetime || null,
      end_time: rows[rows.length - 1]?.datetime || null,
      has_data: rows.length > 0,
      sampling_rate: fixture.processing_summary?.sampling_rate || 1
    }
  }
}
